export const validateDDInvoice = (invoiceData, ddData) => {
    return new Promise((resolve, reject) => {
        try {
            if(invoiceData.length >= ddData.length){ //check if total dd items is match in total invoice items
                let data = invoiceData.map(data => {
                    let ddSKU ="", ddCost=0, ddQty=0, skuStatus = false, costStatus = false, qtyStatus = false;
                    
                    let validate = ddData.filter(e => e.sku === data.sku).length;
                    if(validate > 0){
                        let [{ sku, cost, qty }] = ddData.filter(dd => dd.sku === data.sku);
        
                        skuStatus = data.sku === sku ? true : false;
                        costStatus = data.discountedCost === cost ? true : false;
                        qtyStatus = data.orderedQty === qty ? true : false;
        
                        ddSKU = sku;
                        ddCost = cost;
                        ddQty = qty;
                    }
        
                    return {
                        ...data,
                        ddSKU,
                        ddCost,
                        ddQty,
                        skuStatus,
                        costStatus,
                        qtyStatus
                    }
                })
                resolve(data)
            }else{
                let data = ddData.map(data => {
                    let sku ="dummySKU", cost=0, qty=0, skuStatus = false, costStatus = false, qtyStatus = false,
                    itemNumber="",upc="dummySKU",asin="", description="",btCost=0,orderedQty=0,shippedQty=0,itemCost=0,
                    discountedCost=0,totalPrice=0, isDiscounted=false, status="good"
                    
                    let invoice = invoiceData.filter(e => e.sku === data.sku);
                    if (invoice.length > 0) {
                        sku = invoice[0].sku;
                        cost = invoice[0].discountedCost;
                        qty = invoice[0].orderedQty;
                        itemNumber = invoice[0].itemNumber;
                        upc = invoice[0].upc;
                        asin = invoice[0].asin;
                        description = invoice[0].description;
                        btCost = invoice[0].btCost;
                        orderedQty = invoice[0].orderedQty;
                        shippedQty = invoice[0].shippedQty;
                        itemCost = invoice[0].itemCost;
                        discountedCost = invoice[0].discountedCost;
                        totalPrice = invoice[0].totalPrice;
                        isDiscounted = invoice[0].isDiscounted;
                        status = invoice[0].status;
                        skuStatus = data.sku === sku ? true : false;
                        costStatus = data.cost === cost ? true : false;
                        qtyStatus = data.qty === qty ? true : false;
                    }
                    return {
                        itemNumber,
                        upc,
                        asin, 
                        description, 
                        btCost,
                        orderedQty,
                        shippedQty,
                        itemCost,
                        discountedCost,
                        totalPrice,
                        isDiscounted,
                        status,
                        ddSKU: data.sku,
                        ddCost: data.cost,
                        ddQty: data.qty,
                        sku,
                        cost,
                        qty,
                        skuStatus,
                        costStatus,
                        qtyStatus
                    }
                })
                resolve(data);
            }
        } catch (error) {
            reject(error)
        }
    })
}

export const validateDuplicateDDInvoice = (duplicateData, ddData) => {
    return new Promise((resolve, reject) => {
        try {
            if(duplicateData.length === 0){
                resolve([])
            }else{
                let results = duplicateData.map(data => {
                    let ddSKU ="", ddCost=0, ddQty=0, skuStatus = false, costStatus = false, qtyStatus = false;
                    
                    let validate = ddData.filter(e => e.sku === data.sku).length;
                    if(validate > 0){
                        let [{ sku, cost, qty }] = ddData.filter(dd => dd.sku === data.sku);
        
                        skuStatus = data.sku === sku ? true : false;
                        costStatus = data.discountedCost === cost ? true : false;
                        qtyStatus = data.orderedQty === qty ? true : false;
        
                        ddSKU = sku;
                        ddCost = cost;
                        ddQty = qty;
                    }
        
                    return {
                        ...data,
                        ddSKU,
                        ddCost,
                        ddQty,
                        skuStatus,
                        costStatus,
                        qtyStatus
                    }
                })
                resolve(results)
            }
            
        } catch (error) {
            reject(error)
        }
    })
}